module.exports = __webpack_public_path__ + "static/media/clickyGameTextImage.0f631151.png";